import React, { useState } from 'react';
// A wrapper to remove focus outline when component is clicked assuming it's tab index is set
export const OnClickFocusWrapper = ({ children }) => {
    const [hasOutline, setHasOutline] = useState(true);
    const { onKeyDown, onMouseDown, onKeyUp } = children.props;
    return React.cloneElement(children, {
        onKeyDown: (evt) => {
            if (evt.keyCode === 9) {
                setHasOutline(true);
            }
            if (!!onKeyDown) {
                onKeyDown(evt);
            }
        },
        onKeyUp: (evt) => {
            if (evt.keyCode === 9) {
                setHasOutline(true);
            }
            if (!!onKeyUp) {
                onKeyUp(evt);
            }
        },
        onMouseDown: (evt) => {
            setHasOutline(false);
            if (!!onMouseDown) {
                onMouseDown(evt);
            }
        },
        style: {
            outline: hasOutline ? '' : 'none',
        },
    });
};
